<template>
    <temp-ranking-pending-confirmation>

    </temp-ranking-pending-confirmation>
</template>

<script>
    import TempRankingPendingConfirmation from '../../components/dynamic/ranking/TempRankingPendingConfirmation';
    export default {
        components: {
            TempRankingPendingConfirmation
        },
        data() {
            return {
               
            }
        },
        methods: {
            
        },
        mounted() {
           
        }
    }
</script>

<style scoped>
</style>
